module.exports = __webpack_public_path__ + "img/p-two-step-06.9d56f187.png";